document.addEventListener('DOMContentLoaded', () => {
  const premiumKitItems = document.querySelectorAll('.premium-kit__item')

  if(premiumKitItems) {
    premiumKitItems.forEach(premiumKitItem => {
      const name = premiumKitItem.querySelector('.premium-kit__name')
      if(name.innerText.trim().toLocaleLowerCase() === 'bentley') {
        premiumKitItem.classList.add('premium-kit__item--bentley')
      }
    })
  }
})
